import { PdSettingAPI } from './types'
import { separateNumberSuffix } from '@/utils'

export const pdSettingApi: PdSettingAPI = ky => {
  return {
    async fetchOne({ patientId }) {
      return ky(`patient/${patientId}/pd_setting/`, {
        method: 'get'
      }).json()
    },

    async update({ patientId, payload }) {
      return await ky(`patient/${patientId}/pd_setting/`, {
        method: 'put',
        body: JSON.stringify(separateNumberSuffix(payload))
      }).json()
    },

    async patch({ patientId, payload }) {
      return await ky(`patient/${patientId}/pd_setting/`, {
        method: 'patch',
        body: JSON.stringify(separateNumberSuffix(payload))
      }).json()
    }
  }
}
